import { useTranslation } from 'react-i18next';
import { Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/ui';
import { COUNTRIES } from '@shared/lib/countries';
import { useCategoriesQuery, useCategoryName } from '@entities/taxonomy';

interface FeedFiltersProps {
  q: string;
  category: string | undefined;
  country: string | undefined;
  onChange: (next: { q?: string; category?: string | undefined; country?: string | undefined }) => void;
}

export function FeedFilters({ q, category, country, onChange }: FeedFiltersProps) {
  const { t } = useTranslation();
  // Feed filter narrows by PRODUCT kind — RFQs are tied to marketplace categories.
  const { data: categories } = useCategoriesQuery(['PRODUCT']);
  const localize = useCategoryName();
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Input
        placeholder={t('buyRequests.filter.search')}
        value={q}
        onChange={(e) => onChange({ q: e.target.value })}
        className="max-w-xs"
      />
      <Select
        value={category ?? 'ALL'}
        onValueChange={(v) => onChange({ category: v === 'ALL' ? undefined : v })}
      >
        <SelectTrigger className="w-56">
          <SelectValue placeholder={t('buyRequests.filter.category')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ALL">{t('buyRequests.filter.allCategories')}</SelectItem>
          {(categories ?? []).map((c) => (
            <SelectItem key={c.id} value={c.id}>
              {localize(c)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={country ?? 'ALL'}
        onValueChange={(v) => onChange({ country: v === 'ALL' ? undefined : v })}
      >
        <SelectTrigger className="w-56">
          <SelectValue placeholder={t('buyRequests.filter.country')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ALL">{t('buyRequests.filter.allDestinations')}</SelectItem>
          {COUNTRIES.map((c) => (
            <SelectItem key={c.code} value={c.code}>
              {c.nameEn} ({c.code})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
